import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

// Deep link /work/items/:id → opens the item on its board (or All work) via ?item=
export default function ItemRedirect() {
  const { id } = useParams();
  const navigate = useNavigate();
  useEffect(() => { api.get(`/work/items/${id}`).then((r) => navigate(r.data.board_id ? `/work/boards/${r.data.board_id}?item=${id}` : `/work/all?item=${id}`, { replace: true })).catch(() => navigate("/work", { replace: true })); }, [id, navigate]);
  return <div className="text-slate-400 text-sm">Opening…</div>;
}
